import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component to scroll to top when route changes
 * This ensures that when navigating to a new page, the user starts at the top
 */
export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top when pathname changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth', // Smooth animated scroll
        });
    }, [pathname]);

    return null;
}

export default ScrollToTop;
